import { render, staticRenderFns } from "./GradeTask.vue?vue&type=template&id=556e6a2e&scoped=true&"
import script from "./GradeTask.vue?vue&type=script&lang=js&"
export * from "./GradeTask.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms/theme-checkbox-radio.css?vue&type=style&index=0&id=556e6a2e&scoped=true&lang=css&"
import style1 from "@/assets/css/forms/switches.css?vue&type=style&index=1&id=556e6a2e&scoped=true&lang=css&"
import style2 from "./GradeTask.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e6a2e",
  null
  
)

export default component.exports